
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon-no-refresh",classNames,staticClass],
              style: [{"isolation":"isolate"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","style":"isolation:isolate","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"primary",attrs:{"vector-effect":"non-scaling-stroke","cx":"12","cy":"12","r":"10"}}),_c('path',{staticClass:"secondary",attrs:{"d":"M8.61 14.134a4.005 4.005 0 005.42 1.316l-.74-.74A1 1 0 0114 13h3a1 1 0 011 1v3a1.002 1.002 0 01-1.7.7l-.82-.81a5.98 5.98 0 01-5.086.905 5.808 5.808 0 01-3.205-2.24l1.421-1.421zM15.384 9.86a4.025 4.025 0 00-2.145-1.665 3.997 3.997 0 00-3.269.355l.74.74A1 1 0 0110 11H7a1 1 0 01-1-1V7a1.002 1.002 0 011.7-.7l.82.81a5.979 5.979 0 015.089-.901 5.808 5.808 0 013.194 2.232L15.384 9.86zM8.3 13.538a.99.99 0 00-.777-.578.998.998 0 00-.944.413A.997.997 0 006.5 14.4c.093.216.198.425.306.632L8.3 13.538zM15.672 10.415A1 1 0 1017.5 9.61a4.99 4.99 0 00-.349-.674l-1.479 1.479z","fill":"#FFF"}}),_c('path',{staticClass:"secondary",attrs:{"d":"M6.606 16.006l9.414-9.413c.743-.268 1.743.576 1.374 1.374l-9.44 9.44c-.879.199-1.754-.738-1.348-1.401z","fill":"#FFF"}})])
          )
        }
      }
    